"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.number.constructor");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerLoading = exports.BmLoading = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@onviobr/element");

var _utils = require("@onviobr/services/utils");

var _utils2 = require("./utils");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["<svg\n\t\t\tversion=\"1.1\"\n\t\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\t\txmlns:xlink=\"http://www.w3.org/1999/xlink\"\n\t\t\tx=\"0px\" y=\"0px\"\n\t\t\twidth=\"22px\" height=\"22px\"\n\t\t\tviewBox=\"0 0 22 22\"\n\t\t\tenable-background=\"new 0 0 22 22\"\n\t\t\txml:space=\"preserve\">\n\t\t\t<g transform=\"translate(1 1)\">\n\t\t\t\t<circle\n\t\t\t\t\tfill=\"none\"\n\t\t\t\t\tstroke=\"#E4E4E4\"\n\t\t\t\t\tstroke-width=\"2\"\n\t\t\t\t\tcx=\"10\"\n\t\t\t\t\tcy=\"10\"\n\t\t\t\t\tr=\"10\"/>\n\t\t\t\t<path\n\t\t\t\t\tfill=\"none\"\n\t\t\t\t\tstroke-width=\"2\"\n\t\t\t\t\td=\"M20,10.588c0.001-4.21-2.492-8.021-6.35-9.706 C12.785,0.504,11.372,0.21,9.412,0\"/>\n\t\t\t</g>\n\t\t</svg>\n\t\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t", "\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host {\n\t\tcontain: content;\n\t\tdisplay: none;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tbackground-color: rgba(244, 244, 244, 0.8);\n\t\tz-index: 99999;\n\t}\n\n\t:host svg {\n\t\tanimation-name: loaderRotation;\n\t\tanimation-duration: 1s;\n\t\tanimation-delay: none;\n\t\tanimation-iteration-count: infinite;\n\t\twidth: auto;\n\t\theight: 75%;\n\t\tmax-height: 50px;\n\t}\n\n\t@keyframes loaderRotation {\n\t\t6.25% {\n\t\t\ttransform: rotate(22.5deg);\n\t\t}\n\t\t12.5% {\n\t\t\ttransform: rotate(45deg);\n\t\t}\n\t\t18.75% {\n\t\t\ttransform: rotate(67.5deg);\n\t\t}\n\t\t25% {\n\t\t\ttransform: rotate(90deg);\n\t\t}\n\t\t31.25% {\n\t\t\ttransform: rotate(112.5deg);\n\t\t}\n\t\t37.5% {\n\t\t\ttransform: rotate(135deg);\n\t\t}\n\t\t43.75% {\n\t\t\ttransform: rotate(157.5deg);\n\t\t}\n\t\t50% {\n\t\t\ttransform: rotate(180deg);\n\t\t}\n\t\t56.25% {\n\t\t\ttransform: rotate(202.5deg);\n\t\t}\n\t\t62.5% {\n\t\t\ttransform: rotate(225deg);\n\t\t}\n\t\t68.75% {\n\t\t\ttransform: rotate(247.5deg);\n\t\t}\n\t\t75% {\n\t\t\ttransform: rotate(270deg);\n\t\t}\n\t\t81.25% {\n\t\t\ttransform: rotate(292.5deg);\n\t\t}\n\t\t87.5% {\n\t\t\ttransform: rotate(315deg);\n\t\t}\n\t\t93.75% {\n\t\t\ttransform: rotate(337.5deg);\n\t\t}\n\t\t100% {\n\t\t\ttransform: rotate(360deg);\n\t\t}\n\t}\n\n\t:host svg path {\n\t\tstroke: #ff8000;\n\t\tstroke: var(--accent-color, var(--tr, #ff8000));\n\t}\n\n\t:host([hidden]) {\n\t\tdisplay: none;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _element.css)(_templateObject());

var BmLoading = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmLoading, _BlueElement);

  var _super = (0, _createSuper2.default)(BmLoading);

  (0, _createClass2.default)(BmLoading, null, [{
    key: "is",
    get: function get() {
      return 'bm-loading';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        delay: {
          type: Number,
          attribute: true,
          reflect: true
        },
        active: {
          type: Boolean,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [_utils2.shadowDOMPolyfillContainingBlockFix, _utils2.shadowDOMPolyfillContainingBlockFixChild, _utils2.safariForceRepaint, style];
    }
  }]);

  function BmLoading() {
    var _this;

    (0, _classCallCheck2.default)(this, BmLoading);
    _this = _super.call(this);
    _this.delay = 300;
    _this.active = false;

    _this.createVisibilityChanger();

    return _this;
  }

  (0, _createClass2.default)(BmLoading, [{
    key: "createVisibilityChanger",
    value: function createVisibilityChanger() {
      var _this2 = this;

      this.changeVisibility = (0, _utils.debounce)(function (value) {
        var host = _this2.shadowRoot ? _this2.shadowRoot.host : _this2;
        host.style.display = value;
      }, this.delay);
    }
  }, {
    key: "updated",
    value: function updated(changedProperties) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(BmLoading.prototype), "updated", this).call(this, changedProperties);

      if (changedProperties.has('delay') && this.delay !== changedProperties.get('delay')) {
        this.createVisibilityChanger();
      }

      if (changedProperties.has('active') && this.active !== changedProperties.get('active')) {
        if (this.active) {
          this.changeVisibility('flex');
        } else {
          this.changeVisibility('none');
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return this.html(_templateObject2(), (0, _element.guard)(null, function () {
        return _this3.renderLoader();
      }));
    }
  }, {
    key: "renderLoader",
    value: function renderLoader() {
      return this.svg(_templateObject3());
    }
  }]);
  return BmLoading;
}(_element.BlueElement);

exports.BmLoading = BmLoading;

var registerLoading = function registerLoading() {
  return (0, _element.register)(BmLoading);
};

exports.registerLoading = registerLoading;
